import { ref, watch, computed } from "vue";
import type { Ref } from "vue";
import type { SelectComposeInputConfig } from "./select-compose-input";
/** 多行输入框 */
export default function useMore(
  showValue: Ref<string>,
  opt: SelectComposeInputConfig,
  callback: (val: string) => void
) {
  const visible = ref(false);
  const text = ref("");
  watch(visible, (value) => {
    if (value) {
      text.value = showValue.value
        ? showValue.value
            .split(",")
            .filter((v: string) => v !== "")
            .join("\n")
        : "";
    }
  });
  const handleReset = () => {
    text.value = "";
    showValue.value = "";
    callback("");
  };
  const handleSubmit = () => {
    showValue.value = text.value
      .split("\n")
      .filter((v) => v !== "")
      .join(",");
    callback(showValue.value);
    visible.value = !visible.value;
  };
  return {
    visible,
    text,
    disabled: computed(() => text.value.split("\n").length > opt.rows),
    handleReset,
    handleSubmit,
  };
}
